import React from "react";
import ButtonGroup from "react-bootstrap/esm/ButtonGroup";
import Dropdown from "react-bootstrap/esm/Dropdown";
import { Icon } from "../../components/icon";
import { Locale } from "../../lib/i18n/i18n_provider";
import { LocaleOption, localesByLanguage } from "../../offering/locale_data";
import { Spacer } from "../../offering/spacer";

import "./locale_picker.css";

interface LocalePickerProps {
  locale: Locale;
  localeOptions: LocaleOption[];
  onChangeLocale: (locale: Locale) => void;
}

export function LocalePicker(props: LocalePickerProps) {
  const { locale, localeOptions, onChangeLocale } = props;

  return (
    <Dropdown
      as={ButtonGroup}
      className="locale-picker-v2"
      defaultValue={locale.languageTag}
      onSelect={(language) =>
        language && onChangeLocale(localesByLanguage[language])
      }
    >
      <Dropdown.Toggle>
        <div className="d-flex align-items-center">
          <Icon name="globe" size={16} />
          <Spacer size={4} direction="horizontal" />
          {localeOptions.find((opt) => opt.value === locale.languageTag)?.label}
          <Spacer size={4} direction="horizontal" />
          <Icon name="fi-chevron-down" size={16} />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {localeOptions.map((opt, index) => {
          return (
            <Dropdown.Item key={index} eventKey={opt.value}>
              {opt.label}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}
